<template>
  <div id="kiivi">
    <header class="masthead">
      <div class="intro-body">
        <div class="container">
          <div class="row">
            <div class="mx-auto intro-box">
              <h1 class="brand-heading">Kiivi</h1>
              <p class="intro-text">taking a giant leap into the future</p>
              <p class="intro-chapter"></p>
              <p>The Kiivi™ developer team presents you the new and enhanced AI powered Kiivi™ experience.</p>
              <p>New outside the box server design and customer-centric approach has downgraded the cost making us able
                to provide you the next generation of scalable web services.</p>
              <p>Our upgraded enterprise-grade hybrid cloud computing facility offers our customers high availability,
                redundancy and superior performance.</p>
              <p>It is part of our DNA to bring you the best of breed bleeding edge technology both in hardware and
                software solutions. This new paradigm shift allows our seamlessly integrated cloud network to serve our
                customers in a way
                never seen before.</p>


              <p>But just as it is our duty to bring you the means for your productivity, it is just as important for
                you to contribute to the revolution of the 21st century.</p>
              <strong>Our crowdsourcing based business approach is depending on you!</strong>

              <p>Fasten your seatbelts and brace yourself for the ultimate Kiivi™ experience - the portal to the future
                of web services.</p>

              <div class="d-inline-flex">
                <button class="btn btn-primary me-2" @click="stepIn()">Step in!</button>
                <button class="btn btn-outline-danger ms-2" @click="rndIn()">I'm feeling lucky!</button>
                <button class="btn btn-info ms-2" @click="show_search = !show_search">Search</button>
              </div>
              <div v-if="show_search" class="mt-3">
                <input type="text" class="form-control" placeholder="Enter your search query" v-model="user_search_query" @keyup.enter="fetchUserSearch()">
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container-fluid" id="results" style="margin: 0 auto; width: 100%; background: #FFBBBB;">

      <masonry-wall v-if="step_in" :items="picture_listing" :column-width="300" :gap="16" @keyup.enter="fetchPics()">
        <template #default="{ item }">
          <div class="card">
            <img class="card-img" :src="item.thumb_url" />
            <div class="card-img-overlay parent d-flex align-items-start flex-column">
              <div class="w-100 d-flex justify-content-between mb-auto">
                <div class="visible-on-hover">
                  <h5 class="card-title" style="max-width: 20rem; text-overflow: clip; overflow: hidden;">
                    {{ item.filename }}
                  </h5>
                </div>
                <div v-if="item.video" class="pe-1 pt-1 visible-without-hover hide-on-hover"
                  style="background: rgba(0, 0, 0, 0.7); border-radius:5px; padding-left: 0.1rem;">
                  <font-awesome-icon icon="film" size="2x" />
                </div>
              </div>
              <div class="card-content visible-on-hover d-flex justify-content-between w-100">
                <div class="d-flex flex-wrap pt-1" style="width: 80%;">
                  <div v-for="tag in item.tags" class="ms-1 btn btn-sm btn-light h-50">
                    <span>{{ tag }}</span>
                  </div>
                </div>
                <div class="pe-1 pt-1">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#selain" @click="openModal(item)">
                    <font-awesome-icon icon="search-plus" size="3x" class="push-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </masonry-wall>

      <div class="modal fade" id="selain" ref="modalElement" tabindex="-1" aria-labelledby="selainLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="selainLabel">{{ modal_img.filename }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center">
              <div>
                <video id="video-id" v-if="modal_img.video" class="mw-100" controls autoplay loop>
                  <source :src="kiivi_cdn + 'files/' + modal_img.filename">
                </video>
                <img v-else class="mw-100" :src="kiivi_cdn + 'files/' + modal_img.filename" />
              </div>
              <div>
                <div v-for="tag in modal_img.tags" class="btn btn-primary mt-4 me-2">{{ tag }}</div>
              </div>
              <p class="my-4">{{ modal_img }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="fetching" class="row">
        <font-awesome-icon icon="spinner" size="5x" pulse style="color: grey;" class="mx-auto" />
      </div>

      <div v-if="step_in && !fetching" class="row">
        <button class="btn btn-primary btn-lg mx-auto" @click="!fetching ? fetchPics() : null" style="margin: 30px;">
          Lisää!
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick, getCurrentInstance, watch } from 'vue';
import axios from 'axios';
import { Modal } from 'bootstrap'; // Import Bootstrap's JS for modal control

// --- Props ---
const props = defineProps({
  search_query: String,
  tag_search: String
});

// --- Refs (formerly data()) ---
const kiivi_url = process.env.VUE_APP_API_URL || '/api/';
const kiivi_cdn = process.env.VUE_APP_CDN_URL || '/';
const picture_listing = ref([]);
const site_count = ref(0);
const modal_img = ref({});
const step_in = ref(false);
const fetching = ref(false);
const pics_per_page = 30;
const mode = ref('new');
const fetch_url = ref('');
const show_search = ref(false);
const user_search_query = ref('');

// --- Modal Refs ---
const modalElement = ref(null); // Ref to the modal's DOM element
let modalInstance = null; // Will hold the Bootstrap Modal instance

// --- Access to global properties (for plugins like $scrollTo) ---
const { proxy } = getCurrentInstance();

// --- Methods ---
function fetchRandom() {
  if (mode.value !== "random") {
    site_count.value = 0;
    picture_listing.value = [];
    mode.value = "random";
  }
  fetch_url.value = kiivi_url + "rnd/";
  fetchPics();
}

function fetchNew() {
  if (mode.value !== "new") {
    site_count.value = 0;
    picture_listing.value = [];
    mode.value = "new";
  }
  fetch_url.value = kiivi_url + 'get_links/';
  fetchPics();
}

function fetchSearch() {
  console.log("fetch search");
  if (mode.value !== "search") {
    site_count.value = 0;
    picture_listing.value = [];
    mode.value = "search";
  }
  fetch_url.value = `${kiivi_url}search/${props.search_query}/0`;
  fetchPics();

  if (!step_in.value) {
    step_in.value = true;
    scrollToResults();
  }
}

function fetchUserSearch() {
  console.log("fetch user search");
  if (mode.value !== "user_search") {
    site_count.value = 0;
    picture_listing.value = [];
    mode.value = "user_search";
  }
  fetch_url.value = `${kiivi_url}search/${user_search_query.value}/0`;
  fetchPics();

  if (!step_in.value) {
    step_in.value = true;
    scrollToResults();
  }
}

function fetchTagSearch() {
  console.log("fetch tag search");
  if (mode.value !== "tag_search") {
    site_count.value = 0;
    picture_listing.value = [];
    mode.value = "tag_search";
  }
  fetch_url.value = `${kiivi_url}tag/${props.tag_search}/0`;
  fetchPics();

  if (!step_in.value) {
    step_in.value = true;
    scrollToResults();
  }
}

function fetchPics() {
  setTimeout(() => {
    fetching.value = false;
  }, 750);

  if (!fetching.value) {
    fetching.value = true;

    if (mode.value === 'new') {
      fetch_url.value = `${kiivi_url}get_links/${site_count.value}`;
    }
    if (mode.value === 'search') {
      fetch_url.value = `${kiivi_url}search/${props.search_query}/${site_count.value}`;
    }
    if (mode.value === 'tag_search') {
      fetch_url.value = `${kiivi_url}tag/${props.tag_search}/${site_count.value}`;
    }
    if (mode.value === 'user_search') {
        fetch_url.value = `${kiivi_url}search/${user_search_query.value}/${site_count.value}`;
    }

    site_count.value += 1;

    axios.get(fetch_url.value)
      .then((response) => {
        console.log(response.data.links);
        const videoExtensions = ['webm', 'mp4', 'mov'];

        response.data.links.forEach(x => {
          const ext = x.filename.split('.').pop().toLowerCase();
          x['url'] = `${kiivi_cdn}files/${x['filename']}`;
          x['thumb_url'] = `${kiivi_cdn}thumb/${x['filename'].substring(0, x['filename'].lastIndexOf('.'))}.jpg`;
          x['video'] = videoExtensions.includes(ext);
        });

        let items = response.data.links;
        picture_listing.value = [...picture_listing.value, ...items];
      })
      .catch((error) => {
        console.log('error:', error);
      });
  }
}

function fetchNext() {
  if (modal_img.value && modal_img.value.id) {
    let currentIndex = picture_listing.value.findIndex(x => modal_img.value.id === x.id);
    if (currentIndex >= 0 && currentIndex < picture_listing.value.length - 1) {
      modal_img.value = picture_listing.value[currentIndex + 1];
      updateVideoSource();
    }
  } else {
    console.log('no modal_img');
  }
}

function fetchPrev() {
  if (modal_img.value && modal_img.value.id) {
    let currentIndex = picture_listing.value.findIndex(x => modal_img.value.id === x.id);
    if (currentIndex > 0) {
      modal_img.value = picture_listing.value[currentIndex - 1];
      updateVideoSource();
    }
  } else {
    console.log('no modal_img');
  }
}

// Helper to update video src after next/prev
async function updateVideoSource() {
  await nextTick(); // Wait for v-if to re-render
  if (modal_img.value.video) {
    const video = modalElement.value.querySelector('#video-id');
    if (video) {
      video.src = `${kiivi_cdn}files/${modal_img.value.filename}`;
      video.load(); // Ensure the new source is loaded
      video.play(); // Autoplay next/prev
    }
  }
}

function stepIn() {
  step_in.value = true;
  fetchNew();
  scrollToResults();
}

function rndIn() {
  fetchRandom();
  step_in.value = true;
  scrollToResults();
}

function scrollToResults() {
  const scrollTo = document.querySelector('#results');
  // REFACTOR: Use $scrollTo from vue-scrollto
  if (scrollTo && proxy.$scrollTo) {
    proxy.$scrollTo(scrollTo, 2000);
  }
}

function handleScroll() {
  if (!step_in.value) return;

  let scroll = window.scrollY;
  let height = document.getElementById('kiivi').offsetHeight;

  if (scroll >= height - (window.innerHeight + 60)) {
    console.log('pohjalla');
    if (!fetching.value) {
      fetchPics();
    }
  }
}

// Native modal open function
function openModal(pic) {
  modal_img.value = pic;
}

// Keyboard event handler
function handleKeydown(e) {
  if (e.key === 'ArrowLeft') {
    fetchPrev();
  }
  if (e.key === 'ArrowRight') {
    fetchNext();
  }
}

// --- Lifecycle Hooks ---
onMounted(() => {
  // Add global event listeners
  window.addEventListener("keydown", handleKeydown);
  window.addEventListener('scroll', handleScroll);

  // Initialize native Bootstrap modal
  if (modalElement.value) {
    modalInstance = new Modal(modalElement.value);

    // Listen for the native 'hidden' event to replace @hidden
    modalElement.value.addEventListener('hidden.bs.modal', () => {
      modal_img.value = {}; // Clear modal data
      // Stop video playback
      const video = modalElement.value.querySelector('#video-id');
      if (video) {
        video.pause();
        video.src = "";
      }
    });
  }

  // Logic from original mounted()
  if (props.search_query && props.search_query !== '') {
    fetchSearch();
  }
  if (props.tag_search && props.tag_search !== '') {
    fetchTagSearch();
  }
});

onUnmounted(() => {
  // Clean up global event listeners
  window.removeEventListener("keydown", handleKeydown);
  window.removeEventListener('scroll', handleScroll);

  // Dispose of Bootstrap modal instance
  if (modalInstance) {
    modalInstance.dispose();
  }
});

// --- Watchers ---
watch(() => props.search_query, (newVal, oldVal) => {
  if (newVal) {
    console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    fetchSearch();
  }
});

watch(() => props.tag_search, (newVal, oldVal) => {
  if (newVal) {
    console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    fetchTagSearch();
  }
});

</script>

<style scoped lang="scss">
/* Styles remain unchanged */
.card {
  background-color: transparent;
  border: 0;
  padding: 0;
  border-radius: 0;
  margin-bottom: 0;
}

.card-img-top {
  border-radius: 0;
}

.card-body {
  border: 1px solid;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
